import { EXPERIENCE_CONTENT } from "../Constants/constants";
import { motion } from "framer-motion";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { useVelocitySkew } from "../hooks/useVelocitySkew";
import SectionTitle from "./SectionTitle";

// Cards alternate left/right and stay narrow so the scroll-scrubbed video
// behind the page remains visible beside them (see .stitch/designs).
function ExperienceCard({ experience, index }) {
  const alignRight = index % 2 === 1;
  const skewY = useVelocitySkew();
  const { ref, opacity, offset } = useScrollReveal({
    delay: 0.1,
    distance: 50,
    axis: "x",
    fromRight: alignRight,
  });

  return (
    <motion.div ref={ref} style={{ opacity, x: offset, skewY }}>
      <div
        className={`glass-card mb-10 max-w-2xl rounded-xl p-6 transition-colors duration-300 ${
          alignRight ? "lg:ml-auto" : "lg:mr-auto"
        }`}
      >
        <p className="text-biolum-green mb-1 font-mono text-sm tracking-widest">
          {experience.year}
        </p>
        <h6 className="text-slate-100 mb-2 text-xl font-bold">
          {experience.role} -{" "}
          <span className="text-sm text-biolum-blue">{experience.company}</span>
        </h6>
        <p
          className="text-slate-300 mb-4 text-base text-pretty"
          style={{ whiteSpace: "pre-line" }}
        >
          {experience.description}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {experience.technologies.map((tech, techIndex) => (
            <span
              key={techIndex}
              className="bg-ocean-dark/70 border-biolum-green/20 text-biolum-green rounded border px-2 py-1 text-sm font-medium"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default function Experience() {
  return (
    <section id="experience">
      <div className="mx-auto max-w-5xl py-16">
        <SectionTitle>Experience</SectionTitle>
        {EXPERIENCE_CONTENT.map((experience, index) => (
          <ExperienceCard
            key={`${experience.role}-${experience.company}-${experience.year}`}
            experience={experience}
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
